import DeviceSelector from "components/Functionals/DeviceSelector";
import Icon from "components/MainApp/atoms/Icon/icon";
import InputText from "components/MainApp/atoms/Forms/MainInput";
import styles from "./TagReader.module.scss";
import { useState, useCallback } from "react";
import { WSService } from "services/WSServices";
import i18n from "i18n";
import TagReadInput from "../Input/TagReadInput";

export const TagsReader = ({
  enabledRead,
  typeRead,
  refRead,
  associateRead,
  priorityRead,
  handleSearch,
  auxContent
}) => {
  const [searchedValue, setsearchedValue] = useState("");

  const searchValue = e => {
    setsearchedValue(e.target.value.trim());
  };

  const handleSubmit = function(e) {
    e.preventDefault();
    handleSearch(searchedValue);
    setsearchedValue("");
  };

  const receiveEvent = useCallback(payload => {
    const ws = WSService.getInstance();
    console.log("Message from socket");
    // console.log(payload);

    if (payload.method === "EVENT" && payload.room && ws.inRoom(payload.room)) {
      if ("items" in payload.params) {
        //setmovementItems(payload.params.items);
      } else {
        handleSearch(payload.params.epc);
        setsearchedValue("");
      }
    }
  }, []);

  return (
    <div className={styles["tags-reader-container"]}>
      <div className={styles["tags-reader-content"]}>
        <DeviceSelector
          enabled={enabledRead}
          typeRead={typeRead}
          refRead={refRead}
          associateRead={associateRead}
          priorityRead={priorityRead}
          receiveEvent={receiveEvent}
          includeType={"MOB_READER"}
        />
        <div className={styles["tags-reader-field"]} data-automation-id="input-search">
          <TagReadInput searchValue={searchValue} searchedValue={searchedValue} handleSubmit={handleSubmit} />

          {auxContent && <div className={styles["auxiliar-container"]}>{auxContent}</div>}
        </div>
      </div>
    </div>
  );
};

export default TagsReader;
